/**
 *
 * Categories
 *
 */
import React, { memo } from 'react';
import { DataTable } from './components/view-list';

interface Props {}

export const CourseCategories = memo((props: Props) => {
  return (
    <div>
      <h1>Course Categories</h1>
      <DataTable />
    </div>
  );
});
